import { axiosPublic } from "../../lib/axios";

const usePublicGraphQLQuery = () => {
    return async (query: string) => {
        try {
            return await axiosPublic.post('', { query });
        } catch (err: any) {
            console.error("error fetching data: ", err)
        }
    }
}

export default usePublicGraphQLQuery;